<template>
    <div class="success-con">
        <div>
            <img src="https://source.cimos.cn/cimos/flow_form/images/success_icon.png" alt="" srcset="">
        </div>
        <div class="success-tip">提交成功</div>
    </div>
</template>

<script>
    export default {
        name:"successPage",
    }
</script>

<style scoped lang="scss">
    .success-con{
        text-align: center;
        padding-top: 40%;
        .success-tip{
            margin-top: 20px;
            font-size: 24px;
            letter-spacing: 2px;
        }
    }
</style>